import { render, staticRenderFns } from "./evaluationCom.vue?vue&type=template&id=2d5d6b08&scoped=true&"
import script from "./evaluationCom.vue?vue&type=script&lang=js&"
export * from "./evaluationCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5d6b08",
  null
  
)

export default component.exports